import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import webPreview from "../assets/img.png";

const WEB_APP_URL = "https://app.checkchecker.app/app/signin";

const WebAppPromo: React.FC = () => {
  const { t, i18n } = useTranslation();
  const titleRef = useRef<HTMLHeadingElement>(null);
  const [titleWidth, setTitleWidth] = useState<number>();

  useEffect(() => {
    const measure = () => {
      if (titleRef.current) {
        setTitleWidth(titleRef.current.offsetWidth);
      }
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [t, i18n.language]);

  return (
    <section className="web-promo-section bg-light">
      <Container>
        <Row className="align-items-center">
          <Col md={6} className="mb-4 mb-md-0 text-center">
            <h2 ref={titleRef}>
              {t("webPromo.title")} {" "}
              <span className="badge bg-primary ms-2">
                {t("webPromo.badge")}
              </span>
            </h2>
            <p
              className="web-promo-description"
              style={{ maxWidth: titleWidth ? `${titleWidth}px` : undefined }}
            >
              {t("webPromo.description")}
            </p>
            <div className="d-flex flex-column align-items-center gap-2">
              <a
                href={WEB_APP_URL}
                className="btn btn-primary btn-lg web-promo-cta"
                aria-label={t("webPromo.cta") as string}
              >
                {t("webPromo.cta")}
              </a>
              <small className="text-muted web-promo-note">
                {t("webPromo.note")}
              </small>
            </div>
          </Col>
          <Col md={6} className="text-center">
            <img
              src={webPreview}
              alt="Ukázka webové aplikace CheckChecker"
              className="web-promo-image"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WebAppPromo;
